import styled from "styled-components";

interface InputContainerProps {
  isPasswordInput?: boolean;
  hasError?: boolean;
}

export const InputContainer = styled.div<InputContainerProps>`
  input {
    padding-right: ${(props) => (props.isPasswordInput ? "3rem" : "1rem")};
    border-color: ${(props) => props.hasError && "var(--danger)"};
    caret-color: var(--primary);

    :focus + button {
      color: var(--primary);
    }

    :not(:focus) + button {
      color: ${(props) => props.hasError && "var(--bs-danger)"};
    }

    ::placeholder {
      text-transform: none;
    }
  }
`;

export const PasswordIcon = styled.button`
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  color: inherit;
  line-height: 1;

  &:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
    border-radius: 0.25rem;
  }
`;

export const ErrorContainer = styled.div`
  height: 1.3rem;
`;
